/* eslint-disable jira/filename-case */
import React, { Component, useId } from 'react';
import isEqual from 'lodash/isEqual';
import { useFaceId, type Face } from '@jira/platform__render-face/src/useFaceId.tsx';
import { BreadcrumbActions } from '../controller/index.tsx';
import type { BreadcrumbData } from '../types.tsx';
import type { BreadcrumbProps } from './types.tsx';

// eslint-disable-next-line jira/export/restrict-types-re-export
export type Props = BreadcrumbProps;

type OpsProps = {
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	api: any;
	breadcrumb: BreadcrumbData;
	face: Face;
	id: string;
};

// eslint-disable-next-line jira/react/no-class-components
class BreadcrumbOps extends Component<OpsProps> {
	constructor(props: OpsProps) {
		super(props);

		const { face } = props;

		if (face === 'server') {
			this.onPushBreadcrumb();
		}
	}

	componentDidMount() {
		const { face } = this.props;

		if (face === 'client') {
			this.onPushBreadcrumb();
		}
	}

	componentDidUpdate(prevProps: OpsProps) {
		const { breadcrumb: prevBreadcrumb } = prevProps;
		const { api, breadcrumb, id } = this.props;

		if (!isEqual(prevBreadcrumb, breadcrumb)) {
			api.updateBreadcrumb({
				id,
				...breadcrumb,
			});
		}
	}

	componentWillUnmount() {
		const { api } = this.props;

		api.popBreadcrumb();
	}

	onPushBreadcrumb() {
		const { api, breadcrumb, id } = this.props;

		api.pushBreadcrumb({
			id,
			...breadcrumb,
		});
	}

	render() {
		return null;
	}
}

const Breadcrumb = ({ breadcrumb, children = null }: Props): React.JSX.Element => {
	const face = useFaceId();
	const id = useId();

	return (
		<BreadcrumbActions>
			{(_state, actions) => (
				<>
					<BreadcrumbOps api={actions} breadcrumb={breadcrumb} face={face} id={id} />
					{children}
				</>
			)}
		</BreadcrumbActions>
	);
};

export default Breadcrumb;
